import { render, staticRenderFns } from "./holdingwarrant.vue?vue&type=template&id=3f2b9313"
import script from "./holdingwarrant.vue?vue&type=script&lang=js"
export * from "./holdingwarrant.vue?vue&type=script&lang=js"
import style0 from "./holdingwarrant.vue?vue&type=style&index=0&id=3f2b9313&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports